import { render, staticRenderFns } from "./CallGroupWidget.vue?vue&type=template&id=15c404df"
import script from "./CallGroupWidget.vue?vue&type=script&lang=js"
export * from "./CallGroupWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports